import React from "react";
import {
  Stack,
  Alert,
  Paper,
} from "@mui/material";
import ribbonBackground from "../../assets/ribbon.png";
import MeetingLoadingPage from "./meeting-loading-page";

interface MeetingStatusPageProps {
  isConnecting: boolean;
  errorMessage: string;
}

const MeetingStatusPage: React.FC<MeetingStatusPageProps> = ({ errorMessage, isConnecting }) => {

  if (errorMessage == "Error (403): The meeting has ended") {
    errorMessage = "The meeting has already ended"
  }

  if (isConnecting) {
    return <MeetingLoadingPage />;
  }

  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      sx={{
        minHeight: "100vh",
        backgroundImage:
          `linear-gradient(160deg, rgba(0, 99, 102, 0.73), rgba(0, 76, 131, 0.93)), url(${ribbonBackground})`,
        backgroundBlendMode: "normal",
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      }}
    >
      <Paper
        elevation={20}
        sx={{
          p: 2,
          mt: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          borderRadius: 3,
          width: "100%",
          maxWidth: 600,
          background:
            "linear-gradient(145deg, rgba(255, 255, 255, 0.64) 0%, rgba(255, 255, 255, 0.28) 100%)",
          border: "1px solid rgba(255, 255, 255, 0.5)",
          boxShadow:
            "0 24px 60px rgba(8, 39, 69, 0.35), inset 0 1px 0 rgba(255, 255, 255, 0.35)",
          backdropFilter: "blur(14px)",
          WebkitBackdropFilter: "blur(14px)",
        }}
      >
        <Stack spacing={2} sx={{ width: "100%" }}>
          <Alert
            severity="error"
            sx={{
              fontSize: "1.25rem",
              justifyContent: "center",
              border: "1px solid",
              borderColor: "error.main",
              backgroundColor: "rgba(255,255,255,0.7)",
              "& .MuiAlert-icon": { fontSize: "2rem" },
              "& .MuiAlert-message": { textAlign: "center" },
            }}
          >
            {errorMessage}
          </Alert>
        </Stack>
      </Paper>
      {/* <Copyright color="rgba(255, 255, 255, 0.7)" sx={{ mt: 5 }} /> */}
    </Stack>
  );
};

export default MeetingStatusPage;
